import React from "react"

// Decorative Cortica "complex symbol" sticker icons used in the clinic hero badges.
// Artwork taken from the brand SVGs:
//   cortica_complexsymbols_diagnosticcare.svg  (stethoscope)
//   cortica_complexsymbols_research.svg        (magnifier + network)

export const StethoscopeIcon = () => (
  <svg
    aria-hidden="true"
    className="ClinicHero__badge-icon"
    fill="none"
    viewBox="0 0 172 172"
  >
    <path
      d="M58.0014 46.3038H55.7014C53.4014 46.3038 51.5014 44.4038 51.6014 42.1038C51.6014 39.8038 53.5014 37.9038 55.8014 38.0038H58.1014C60.4014 38.0038 62.3014 39.9038 62.2014 42.2038C62.2014 44.4038 60.3014 46.3038 58.0014 46.3038Z"
      stroke="#122F4E"
      strokeMiterlimit="10"
    />
    <path
      d="M79.4008 46.4035H81.7008C84.0008 46.4035 85.9008 44.6035 85.9008 42.3035C85.9008 40.0035 84.1008 38.1035 81.8008 38.1035H79.5008C77.2008 38.1035 75.3008 39.9035 75.3008 42.2035C75.3008 44.5035 77.1008 46.4035 79.4008 46.4035Z"
      stroke="#122F4E"
      strokeMiterlimit="10"
    />
    <path
      d="M85.9006 42.2041C89.9006 42.2041 98.3006 45.7041 98.2006 62.7041C98.1006 77.4041 85.5006 103.904 68.3006 103.704C51.1006 103.504 38.9006 77.0041 39.0006 62.3041C39.1006 45.2041 47.6006 41.9041 51.6006 42.0041"
      stroke="#122F4E"
      strokeMiterlimit="10"
    />
    <path
      d="M68.3009 103.703C68.3009 103.703 65.9009 129.603 81.2009 137.203C102.401 147.803 110.201 124.603 110.601 115.303C110.901 109.003 106.601 101.503 96.9009 103.403C85.4009 105.603 84.3009 127.903 107.001 128.403C131.301 128.903 127.501 80.2031 127.501 80.2031"
      stroke="#122F4E"
      strokeDasharray="4 4"
      strokeMiterlimit="10"
    />
    <path
      d="M127.602 79.9039C129.646 79.9039 131.302 78.2474 131.302 76.2039C131.302 74.1605 129.646 72.5039 127.602 72.5039C125.559 72.5039 123.902 74.1605 123.902 76.2039C123.902 78.2474 125.559 79.9039 127.602 79.9039Z"
      stroke="#122F4E"
      strokeMiterlimit="10"
    />
    <path
      d="M122.201 86.1043C118.701 84.2043 116.301 80.4043 116.301 76.1043C116.301 69.9043 121.401 64.9043 127.601 64.9043C133.801 64.9043 138.801 70.0043 138.801 76.2043C138.801 80.4043 136.401 84.1043 132.901 86.0043"
      stroke="#122F4E"
      strokeMiterlimit="10"
    />
  </svg>
)

export const NetworkSearchIcon = () => (
  <svg
    aria-hidden="true"
    className="ClinicHero__badge-icon"
    fill="none"
    viewBox="0 0 172 172"
  >
    <path
      d="M85.1984 116.2C105.523 116.2 121.998 99.7237 121.998 79.3996C121.998 59.0755 105.523 42.5996 85.1984 42.5996C64.8744 42.5996 48.3984 59.0755 48.3984 79.3996C48.3984 99.7237 64.8744 116.2 85.1984 116.2Z"
      stroke="#122F4E"
      strokeDasharray="4 4"
      strokeMiterlimit="10"
    />
    <path
      d="M40.4 105.7C43.3823 105.7 45.8 103.283 45.8 100.3C45.8 97.3181 43.3823 94.9004 40.4 94.9004C37.4177 94.9004 35 97.3181 35 100.3C35 103.283 37.4177 105.7 40.4 105.7Z"
      fill="#122F4E"
    />
    <path
      d="M60.2008 84.8996C63.1831 84.8996 65.6008 82.4819 65.6008 79.4996C65.6008 76.5173 63.1831 74.0996 60.2008 74.0996C57.2184 74.0996 54.8008 76.5173 54.8008 79.4996C54.8008 82.4819 57.2184 84.8996 60.2008 84.8996Z"
      fill="#122F4E"
    />
    <path
      d="M103.9 66.1008C106.882 66.1008 109.3 63.6831 109.3 60.7008C109.3 57.7184 106.882 55.3008 103.9 55.3008C100.918 55.3008 98.5 57.7184 98.5 60.7008C98.5 63.6831 100.918 66.1008 103.9 66.1008Z"
      fill="#122F4E"
    />
    <path
      d="M130.002 66.1008C132.984 66.1008 135.402 63.6831 135.402 60.7008C135.402 57.7184 132.984 55.3008 130.002 55.3008C127.019 55.3008 124.602 57.7184 124.602 60.7008C124.602 63.6831 127.019 66.1008 130.002 66.1008Z"
      fill="#122F4E"
    />
    <path
      d="M85.2008 84.3C88.1831 84.3 90.6008 81.8823 90.6008 78.9C90.6008 75.9177 88.1831 73.5 85.2008 73.5C82.2184 73.5 79.8008 75.9177 79.8008 78.9C79.8008 81.8823 82.2184 84.3 85.2008 84.3Z"
      fill="#122F4E"
    />
    <path
      d="M42.8008 97.1992L61.0008 78.8992H86.4008L104.601 60.6992H130.001"
      stroke="#122F4E"
      strokeMiterlimit="10"
    />
    <path
      d="M116.901 104.5L138.001 125.7C140.101 127.8 140.801 130.4 138.701 132.5C136.601 134.6 134.001 133.9 131.901 131.8L110.801 110.6"
      stroke="#122F4E"
      strokeMiterlimit="10"
    />
    <path d="M65.6992 61.9004H79.7992" stroke="#122F4E" strokeMiterlimit="10" />
    <path d="M75.8984 51.4004H93.7984" stroke="#122F4E" strokeMiterlimit="10" />
    <path d="M102.398 73.5H116.698" stroke="#122F4E" strokeMiterlimit="10" />
    <path d="M95.6992 83.5H115.499" stroke="#122F4E" strokeMiterlimit="10" />
    <path d="M69.8984 92.9004H100.598" stroke="#122F4E" strokeMiterlimit="10" />
    <path d="M75.8984 104H93.7984" stroke="#122F4E" strokeMiterlimit="10" />
    <path
      d="M84.8984 120C107.266 120 125.398 101.868 125.398 79.5C125.398 57.1325 107.266 39 84.8984 39C62.5309 39 44.3984 57.1325 44.3984 79.5C44.3984 101.868 62.5309 120 84.8984 120Z"
      stroke="#122F4E"
      strokeMiterlimit="10"
    />
  </svg>
)
